import React, { useState, useEffect } from "react";
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Button,
  Card,
  CardImg,
  CardBody,
  CardTitle,
  CardText,
  Col,
  Row,
} from "reactstrap";
import "./PPOffCanvasComponent.css";
import { getPlantById } from "../../api/processing plant/plantApi.js";

const PPOffCanvasComponent = ({ isOpen: propIsOpen, onToggle, plantId }) => {
  console.log("PP id:", plantId);
  const [isOpen, setIsOpen] = useState(false);
  const [plantDetails, setDetails] = useState({});

  useEffect(() => {
    setIsOpen(propIsOpen);
  }, [propIsOpen]);

  useEffect(() => {
    const fetchPlantData = async () => {
      try {
        const data = await getPlantById(plantId);
        console.log("Plant data:", data);
        setDetails(data.data);
      } catch (error) {
        console.error("Error fetching plant data:", error);
      }
    };
    if (plantId) {
      fetchPlantData();
    }
  }, [plantId]);

  const toggle = () => {
    setIsOpen(!isOpen);
    if (onToggle) onToggle(!isOpen);
  };

  // Sample data (replace with dynamic data if needed)
  const companyData = {
    name: plantDetails.companyName || "",
    certifications: plantDetails.certifications || [""],
    about: plantDetails.aboutCompany || "",
    owner: plantDetails.ownerName || "",
    employees: plantDetails.employees || "0",
    location: plantDetails.location || "",
    website: plantDetails.website || "No Site",
    established: plantDetails.established || "N/A",
    profileImage: plantDetails.profileImage,
    pictures: [
      plantDetails.image1,
      plantDetails.image2,
      plantDetails.image3,
      plantDetails.image4,
    ],
    postOrders: [
      // {
      //   image: 'https://via.placeholder.com/100?text=Order+1',
      //   date: '11/09/2024',
      //   location: 'California',
      //   status: 'Pending',
      //   code: 'LK7800-LK7800',
      // },
      // {
      //   image: 'https://via.placeholder.com/100?text=Order+2',
      //   date: '11/09/2024',
      //   location: 'California',
      //   status: 'Pending',
      //   code: 'LK7800-LK7800',
      // },
      // {
      //   image: 'https://via.placeholder.com/100?text=Order+3',
      //   date: '11/09/2024',
      //   location: 'California',
      //   status: 'Pending',
      //   code: 'LK7800-LK7800',
      // },
    ],
    workingDays: plantDetails.workingHours || {},
    mapPlaceholder: "https://via.placeholder.com/200x150?text=Company+Location",
    locationAddress: "No. 239/7, Kaduwela Road, Pittugala, Sri Lanka",
  };

  return (
    <div>
      {/* <Button
        color="primary"
        onClick={toggle}
      >
        Open Offcanvas
      </Button> */}
      <Offcanvas isOpen={isOpen} direction="end" className="pp-offcanvas">
        {/* <OffcanvasHeader toggle={toggle}>
          <h5>{companyData.name}</h5>
        </OffcanvasHeader> */}
        <OffcanvasBody>
          <div className="row canvass-content">
            {/* Left Column */}
            <div className="col-md-7 position-relative first-column col-padding-30">
              <Button
                className="pp-close-btn mb-5"
                onClick={toggle}
                aria-label="Close"
              >
                &times;
              </Button>

              <div className="pp-section">
                <div className="company-logo">
                  <img src={companyData.profileImage} alt="Company Logo" />
                </div>
                <h6>About Company</h6>
                <p>{companyData.about}</p>
              </div>
              <div className="company-profile pb-3">
                <h6>Profile View</h6>

                <p className="profile-row">
                  <span className="label">Owner Name:</span>
                  <span className="value">{companyData.owner}</span>
                </p>

                <p className="profile-row">
                  <span className="label">Employees:</span>
                  <span className="value">{companyData.employees}</span>
                </p>

                <p className="profile-row">
                  <span className="label">Location:</span>
                  <span className="value">{companyData.location}</span>
                </p>

                <p className="profile-row">
                  <span className="label">Website:</span>
                  <span className="value">{companyData.website}</span>
                </p>

                <p className="profile-row">
                  <span className="label">Established:</span>
                  <span className="value">{companyData.established}</span>
                </p>

                <button className="download-btn">Download Profile</button>
              </div>

              <div className="orders-section">
                <h6>Past Orders</h6>
                {companyData.postOrders.length > 0 ? (
                  companyData.postOrders.map((order, index) => (
                    <div key={index} className="order-item">
                      <div className="d-flex">
                        <img
                          src={order.image}
                          alt="Order"
                          className="order-image"
                        />
                        <div>
                          <p>
                            <strong>{order.item}</strong>
                          </p>
                          <p>
                            {order.date} | {order.location}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex mt-4 ml-1">
                        <p className="mr-4">{order.price}</p>
                        <span
                          style={{
                            margin: "0 10px",
                            display: "inline-block",
                            width: "2px",
                            height: "26px",
                            backgroundColor: "#ccc",
                            verticalAlign: "middle",
                          }}
                        />
                        <span className="status-button-warning" size="sm">
                          {order.status}
                        </span>
                      </div>
                    </div>
                  ))
                ) : (
                  <p>No orders available</p>
                )}
              </div>
            </div>

            {/* Right Column */}
            <div className="col-md-5 secound-column col-padding-30">
              <h4>{companyData.name}</h4>
              <div className="company-certifications">
                <h6>Compliance and Certification</h6>
                {companyData.certifications.map((cert, index) => (
                  <p key={index}>
                    <strong>{cert.title}</strong> <br /> {cert.period}
                  </p>
                ))}
              </div>
              <div className="company-pictures">
                <h6>Pictures</h6>

                <Row>
                  {companyData.pictures.map((pic, index) => (
                    <Col sm={6} className="p-2" key={index}>
                      <img
                        key={index}
                        src={pic}
                        alt={`Picture ${index + 1}`}
                        className="picture-item"
                        style={{ width: "100%" }}
                      />
                    </Col>
                  ))}
                </Row>
              </div>

              <div className="company-working-days">
                <h6>Working Days</h6>
                {Object.entries(companyData.workingDays).map(
                  ([dayName, details], index) => (
                    <div className="working-day-row" key={index}>
                      <span className="day-label">{dayName}</span>
                      <span className="day-details">
                        {details
                          ? details.is24Hours
                            ? "24 Hours"
                            : `${details.start} - ${details.end}`
                          : "Closed"}
                      </span>
                    </div>
                  )
                )}
              </div>

              <div className="company-location">
                <h6>Company Location</h6>
                <iframe
                  className="location-map"
                  title="Company Location"
                  src={`https://www.google.com/maps?q=${encodeURIComponent(
                    companyData.locationAddress
                  )}&output=embed`}
                  width="100%"
                  height="150"
                  style={{ border: 0 }}
                  borderRadius="100px"
                  allowFullScreen=""
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </OffcanvasBody>
      </Offcanvas>
    </div>
  );
};

export default PPOffCanvasComponent;
